<template>
    <v-container :class="{'pa-0' : $vuetify.breakpoint.xsOnly}" id="body-wrapper">
        <v-layout row wrap>
            <v-flex v-if="getEstablishment.email" xs12>
                <v-card>
                    <v-card-title>
                        <span class="title hidden-sm-and-up">
                            {{ $t('joinUs.title') }}
                        </span>
                        <span class="headline hidden-md-and-up hidden-xs-only">
                            {{ $t('joinUs.title') }}
                        </span>
                        <span class="display-1 hidden-sm-and-down">
                            {{ $t('joinUs.title') }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex v-if="getEstablishment.phone" class="xs12 mb-4 subheading">
                                {{ $t('joinUs.byPhone') }} {{ getEstablishment.phone }}
                            </v-flex>
                            <v-flex class="xs12 subheading">
                                {{ $t('joinUs.byMail') }}
                            </v-flex>
                            <v-flex xs12 mt-6>
                                <v-form v-model="isFormValid" ref="formJoin">
                                    <v-layout row wrap>
                                        <v-flex
                                            xs12
                                            sm10
                                            offset-sm1
                                            md5
                                            offset-md0>
                                            <v-flex>
                                                <v-text-field
                                                    v-model="firstName"
                                                    :label="$t('form.firstName')"
                                                    append-icon="fas fa-user"
                                                    outlined
                                                    :rules="[v => !!v || $t('form.errors.firstName')]"
                                                />
                                            </v-flex>

                                            <v-flex>
                                                <v-text-field
                                                    v-model="lastName"
                                                    :label="$t('form.lastName')"
                                                    append-icon="fas fa-user"
                                                    outlined
                                                    :rules="[v => !!v || $t('form.errors.lastName')]"
                                                />
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field
                                                    v-model="phone"
                                                    :label="$t('form.phone')"
                                                    append-icon="fas fa-phone"
                                                    outlined
                                                    :rules="[v => v.length ===0 || v.length === 16 || $t('form.errors.phoneFormat')]"
                                                    v-mask="$t('base.phoneMask')"
                                                />
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field
                                                    v-model="email"
                                                    :label="$t('form.email')"
                                                    append-icon="fas fa-envelope"
                                                    type="email"
                                                    outlined
                                                    :rules="[v => !!v || $t('form.errors.email'),
                                                             v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || $t('form.errors.emailFormat')]"
                                                />
                                            </v-flex>
                                        </v-flex>
                                        <v-flex
                                            xs12
                                            sm10
                                            offset-sm1
                                            md6
                                            offset-md1>
                                            <v-flex>
                                                <v-textarea
                                                    v-model="message"
                                                    :label="$t('form.message')"
                                                    append-icon="fas fa-comment"
                                                    outlined
                                                    counter="500"
                                                    maxlength="500"
                                                    :rules="[v => !!v || $t('form.errors.message')]"
                                                />
                                            </v-flex>
                                            <v-flex text-center>
                                                <vue-recaptcha
                                                    class="g-recaptcha"
                                                    :sitekey="captchaKey"
                                                    ref="recaptcha"
                                                    @verify="isRecaptchaValid = true"
                                                    @expired="isRecaptchaValid = false"
                                                />
                                            </v-flex>
                                            <v-flex mt-4 text-center>
                                                <v-btn
                                                    rounded
                                                    color="button-secondary-color"
                                                    :disabled="!isRecaptchaValid || !isFormValid"
                                                    @click="joinUsAPI"
                                                >
                                                    {{ $t('joinUs.send') }}
                                                </v-btn>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex v-else class="text-center">
                {{ $t("errorPage.content") }}
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { mapActions, mapGetters } from 'vuex';
import { formatPhoneNumber } from '@/utils';

export default {
    name: 'join',
    components: { VueRecaptcha },
    data() {
        return {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            message: '',
            isFormValid: false,
            isRecaptchaValid: false,
        };
    },
    watch: {
        locale(newLocale, oldLocale) {
            if (newLocale && oldLocale &&
                    newLocale !== oldLocale) {
                this.$refs.recaptcha.reset();
            }
        },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            captchaKey: 'captchaKey',
            getEstablishment: 'establishment/getEstablishment',
        }),
    },
    methods: {
        ...mapActions({
            sendJoinUsMail: 'other/sendJoinUsMail',
        }),
        formatPhoneNumber(val) {
            return formatPhoneNumber(val);
        },
        /**
             *  Prepare the payload and call the store action to
             *  send the join us mail
             */
        joinUsAPI() {
            const payload = {
                establishment: this.getEstablishment.id,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                message: this.message,
            };

            this.sendJoinUsMail(payload)
                .then(() => {
                    this.$store.commit('snackbar/SET_SNACK', { message: this.$i18n.t('cancel.couponLostSuccess'), color: 'success', timeout: 5000 });

                    // Reset the form
                    this.firstName = '';
                    this.lastName = '';
                    this.phone = '';
                    this.email = '';
                    this.message = '';
                    this.isFormValid = false;
                    this.isRecaptchaValid = false;

                    this.$refs.formJoin.reset();
                    this.$refs.recaptcha.reset();
                })
                .catch(error => {
                    // Reset the recaptcha on action
                    this.$refs.recaptcha.reset();
                    throw error;
                });
        },
    },
};
</script>

<style lang="scss">

</style>
